import { z } from 'zod';

export const DiscountSchema = z.object({
  discount_id: z.string(),
  key: z.string().nullable(),
  permyriad: z.number().nullable(),
  valid_from: z.string().nullable(),
  valid_until: z.string().nullable(),
  discount_type: z.string().nullable(),
});
